import styled from "styled-components";

export const Container = styled.div`
  margin-top: 80px; // remover essa linha quando nao houver mais header
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 32px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 80px);
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const HistoricoPanelPlaceholder = styled.div`
  width: 340px;
  flex-shrink: 0;
`;

export const HistoricoPanel = styled.div`
  position: fixed;
  top: 112px;
  right: 32px;
  width: 340px;
  height: calc(100vh - 112px - 32px);
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px 16px 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 10;

  h3 {
    font-family: Inter-Medium;
    font-size: 18px;
    color: #2d5bff;
    margin: 0 0 16px 0;
    padding-bottom: 12px;
    border-bottom: 2px solid #2d5bff;
    text-align: center;
    flex-shrink: 0;
  }
`;
